import { Card, CardContent } from '@/components/ui/card'
import type { EmailReportTotals } from '@/models/emailReport'

function pct(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`
}

export function ReportingSummaryCards({ totals }: { totals: EmailReportTotals }) {
  const cards = [
    { label: 'Sent', value: totals.sent.toLocaleString() },
    { label: 'Open rate', value: pct(totals.openRate) },
    { label: 'Click rate', value: pct(totals.clickRate) },
  ]
  return (
    <div className="grid grid-cols-3 gap-4">
      {cards.map((c) => (
        <Card key={c.label}>
          <CardContent className="p-4">
            <div className="text-sm text-neutral-500">{c.label}</div>
            <div className="text-2xl font-semibold">{c.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
